/**
 * Anasayfa widget kayıt defteri — 25.08 md, madde 8.
 *
 * Önceki durumda widget'lar veri değil ELLE YAZILMIŞ JSX'ti: hangisinin
 * görüneceği derleme zamanında sabitti, ekleme/çıkarma mümkün değildi. Burada
 * her widget bir kayıt haline gelir; `DashboardContent` bu listeyi dolaşarak
 * çizer, kullanıcı da açıp kapatabilir.
 *
 * Düzen `kullanici_pano_tercih` tablosunda kullanıcı bazlı saklanır
 * (GET/PUT /pano/tercih). localStorage bilinçli olarak KULLANILMADI: düzen
 * cihazlar arasında taşınmalı, localStorage cihaz-yereldir.
 */

/** Widget anahtarları — DB'de saklanan düzen bu anahtarları taşır. */
export const WIDGET_TANIMLARI = [
  {
    anahtar: 'bekleyen_surecler',
    ad: 'Bekleyen Süreçlerim',
    aciklama: 'Size atanmış açık süreç görevleri',
    genislik: 'tam',      // tam satır
    varsayilan: true,
  },
  {
    anahtar: 'feed',
    ad: 'Akış',
    aciklama: 'Şirket içi paylaşımlar',
    genislik: 'yarim',
    varsayilan: true,
  },
  {
    anahtar: 'todo',
    ad: 'Yapılacaklar',
    aciklama: 'Kişisel yapılacaklar listeniz',
    genislik: 'yarim',
    varsayilan: true,
  },
  {
    anahtar: 'hizli_erisim',
    ad: 'Hızlı Erişim',
    aciklama: 'Favori menüleriniz',
    genislik: 'yarim',
    varsayilan: true,
  },
  {
    anahtar: 'kayitli_pivotlar',
    ad: 'Kayıtlı Pivotlar',
    aciklama: 'Kaydettiğiniz pivot grafikleri',
    genislik: 'yarim',
    varsayilan: true,
  },
];

const ANAHTARLAR = WIDGET_TANIMLARI.map((w) => w.anahtar);

/** Tercih kaydı yokken kullanılacak düzen. */
export const varsayilanDuzen = () =>
  WIDGET_TANIMLARI.map((w) => ({ anahtar: w.anahtar, gorunur: w.varsayilan }));

/**
 * DB'den gelen düzeni tanımlarla birleştirir.
 *
 * Neden gerekli: sonradan eklenen bir widget eski kayıtlarda yoktur (görünmez
 * kalırdı), silinen bir widget ise kayıtta artık olarak durur (çizilemez).
 * Birleştirme sırayı kayıttan, kümeyi tanımlardan alır.
 */
export const duzeniBirlestir = (kayitliDuzen) => {
  if (!Array.isArray(kayitliDuzen) || kayitliDuzen.length === 0) {
    return varsayilanDuzen();
  }
  const gecerli = kayitliDuzen.filter((d) => ANAHTARLAR.includes(d?.anahtar));
  const bilinen = new Set(gecerli.map((d) => d.anahtar));
  const eksikler = WIDGET_TANIMLARI
    .filter((w) => !bilinen.has(w.anahtar))
    .map((w) => ({ anahtar: w.anahtar, gorunur: w.varsayilan }));
  return [...gecerli.map((d) => ({ anahtar: d.anahtar, gorunur: d.gorunur !== false })),
          ...eksikler];
};

export const tanimBul = (anahtar) =>
  WIDGET_TANIMLARI.find((w) => w.anahtar === anahtar) || null;

export default { WIDGET_TANIMLARI, varsayilanDuzen, duzeniBirlestir, tanimBul };
